const publicUrl = process.env.PUBLIC_URL || '';

export const LOGO_SRC = `${publicUrl}/logo192.png`;
export const LOGO512_SRC = `${publicUrl}/logo512.png`;
